export const ACQUISITION_DEVICE = 'x.com.kistler.acquisition.device'
export const SUPPORTED_CONTROLLER_TYPES = ['x.com.kistler.kgate.controller']
export const ACQUISITION_CHANNEL = 'x.com.kistler.acquisition.channel'
export const VIRTUAL_MODULE = 'x.com.kistler.kistudio.module'
